import PropTypes from 'prop-types';
import React from 'react';
import NavLink from '../NavLink/Navlink';

import { getSiteUrl } from '@utils/config';

const SectionNavLink = ({
  activeClassName,
  internalLink = true,
  addSiteUrl = false,
  siteUrlOverride = '',
  to,
  children,
  ...props
}) => {
  if (internalLink) {
    return (
      <NavLink activeClassName={activeClassName} to={to} {...props}>
        {children}
      </NavLink>
    );
  } else {
    let url = to;

    if (siteUrlOverride !== '') {
      url = `${siteUrlOverride}${to}`;
    } else {
      if (addSiteUrl) {
        url = `${getSiteUrl()}${to}`;
      }
    }

    return (
      <a href={url} {...props}>
        {children}
      </a>
    );
  }
};

SectionNavLink.propTypes = {
  activeClassName: PropTypes.any,
  addSiteUrl: PropTypes.bool,
  children: PropTypes.any,
  internalLink: PropTypes.bool,
  siteUrlOverride: PropTypes.string,
  to: PropTypes.any,
};

export default SectionNavLink;
